import React, { useEffect, useRef, useState, useMemo } from "react";
import { Button, Divider, Flex, Form, Select, Space } from "antd";
import { Modal } from "react-bootstrap";
import { useModalForm } from "../../../../utils/hooks/useModalForm";
import MainPagetitle from "../../../layouts/MainPagetitle";
import LeadsCenteredModal from "./LeadsCenteredModal";
import LeadsSearch from "./LeadsSearch/LeadsSearch";
import moment from "moment";
import LeadCard from "./LeadCard";

const LeadManagement = (props) => {
  const PERSONA = props?.$store?.persona;
  const isAdmin = props?.$store?.persona === _enum.ROUTE_PERSONAS.admin;

  // pagination & sorting
  const [search, setSearch] = useState({
    page: 1,
    limit: 10,
    order_by: "updatedAt",
    order_direction: "DESC",
  });

  // modal refs/data
  const [popupBulkUploadFields, setPopupBulkUploadFields] = useState({});

  const [popupBulkUploadData, setPopupBulkUploadData] = useState({});

  // flags
  const [activeKey, setActiveKey] = useState(null);
  const [activeOpsKey, setActiveOpsKey] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [isadmin, setIsadmin] = useState(false);
  const [isTelecaller, setIsTelecaller] = useState(false);
  const [isOps, setIsOps] = useState(false);
  const [isFetching, setIsFetching] = useState(true);

  const [editData, setEditData] = useState(null);
  const [employees, setEmployees] = useState([]);
  const [roles, setRoles] = useState([]);
  const initialColumnsRef = useRef([
    {
      dataIndex: "lead_name",
      title: "Name",
      render: (text, record) => (
        <>
          <span className="text-primary">{text}</span>
          {record?.isVerified && (
            <i className="fa fa-circle-check text-red ms-2" />
          )}
        </>
      ),
    },
    { dataIndex: "mobile_number", title: "Mobile No." },
    { dataIndex: "location", title: "Location" },
    {
      dataIndex: "source",
      title: "Source",
      render: (text) => text?.toTitleCase() || "-",
    },
    {
      dataIndex: "created_at",
      title: "Created Date",
      render: (text) =>
        text ? new Date(text).dateToDDMMYYYY(new Date(text)) : "-",
    },
    {
      dataIndex: "status",
      title: "Lead Status",
      render: (text) => (
        <AppTag color={_enum.STATUS_COLOR_MAP[text?.toLowerCase()]}>
          {text?.toTitleCase() || "-"}
        </AppTag>
      ),
    },
    {
      dataIndex: "assignedEmployee",
      title:
        PERSONA === _enum.ROUTE_PERSONAS.ops ? "Assigned By" : "Assigned To",
      render: (_, record) => {
        if (PERSONA === _enum.ROUTE_PERSONAS.ops) {
          return record?.assignedByEmployee?.full_name || "-";
        } else {
          return record?.assignedEmployee?.full_name || "-";
        }
      },
    },
  ]);

  const [columns, setColumns] = useState(initialColumnsRef.current);
  const [rowcount, setRowcount] = useState(0);

  // selection
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [assignDept, setAssignDept] = useState({});
  const [notSelected, setNotSelected] = useState(true);

  useEffect(
    () => setNotSelected(selectedRowKeys.length === 0),
    [selectedRowKeys]
  );

  const rowSelection = useMemo(
    () => ({
      selectedRowKeys,
      onChange: (newKeys) => setSelectedRowKeys(newKeys),
      getCheckboxProps: (record) => {
        const { role } = props?.$store?.user || {};
        if (
          role === _enum.ROUTE_PERSONAS.telecaller &&
          record?.status !== "INTERESTED"
        )
          return { disabled: true };
        return {};
      },
    }),
    [selectedRowKeys, props]
  );

  // useModalForm
  const modalConfigs = {
    leadInfo: [
      {
        name: "lead_name",
        label: "Customer Name",
        type: "text",
        placeholder: "Please Enter",
        required: true,
        disableOnEdit: PERSONA === _enum.ROUTE_PERSONAS.admin ? false : true,
      },
      {
        name: "mobile_number",
        label: "Mobile No.",
        type: "text",
        rules: _enum.MOBILE_NUM_RULE,
        placeholder: "Please Enter",
        required: true,
        disableOnEdit: PERSONA === _enum.ROUTE_PERSONAS.admin ? false : true,
      },
      {
        name: "email_address",
        label: "Email ID",
        type: "email",
        // rules: _enum.EMAIL_RULE,
        placeholder: "Please Enter",
        // required: true,
      },
      {
        name: "source",
        label: "Source",
        type: "select",
        options: _enum.SOURCES,
      },
      {
        name: "loan_amount",
        label: "Req. Loan Amt.",
        type: "number",
        placeholder: "Please Enter",
      },
      {
        name: "location",
        label: "Location",
        type: "text",
        placeholder: "Please Enter",
      },
      {
        name: "status",
        label: "Status",
        type: "select",
        options: _enum.ADMIN_LEADS_STATUS_2,
        placeholder: "Please Enter",
      },
      {
        name: "product_type",
        label: "Product Type",
        type: "select",
        options: [],
        fetchOptions: () => props.apis.apiGetProductTypes(),
        placeholder: "Please enter",
        required: true,
      },
      {
        name: "employee_type",
        label: "Employment Type",
        type: "select",
        options: _enum.LEAD_EMPLOYEE_TYPE,
        placeholder: "Please Enter",
        // required: true,
      },
      {
        name: "desire_property",
        label: "Do you already have a property in mind?",
        type: "text",
      },
      {
        name: "remarks",
        label: "Remarks",
        type: "textarea",
        colspan: 24,
      },
    ],
    opsLeadInfo: [
      {
        label: "Customer Name",
        name: "lead_name",
        type: "text",
        placeholder: "Please Enter",
        readOnly: true,
      },
      {
        label: "Mobile No.",
        name: "mobile_number",
        type: "text",
        readOnly: true,
        placeholder: "Please Enter",
      },
      {
        label: "Bank Name",
        name: "bank_name",
        type: "select",
        options: [],
        fetchKey: "bank_name",
        fetchOptions: async () => {
          const data = await props.apis.apiGetBanknames();
          if (data) return data;
          return [];
        },
        placeholder: "Please Select",
      },
      {
        label: "Application Status",
        name: "status",
        type: "select",
        options: _enum.OPS_LEADS_STATUS,
        required: true,
        placeholder: "Please Enter",
      },
      {
        label: "Application No.",
        name: "application_number",
        type: "text",
        required: true,
        placeholder: "Please Enter",
        showWhen: (data) => data.status === "APPLIED",
      },
      {
        label: "Application Date",
        name: "application_date",
        type: "date",
        disabledDate: (current) => {
          return current && current > moment().endOf("day");
        },
        required: true,
        placeholder: "Please Enter",
        showWhen: (data) => data.status === "APPLIED",
      },
      {
        label: "Loan Amt",
        name: "loan_amount",
        type: "number",
        placeholder: "Please Enter",
      },
      {
        label: "Assigned By",
        name: "assignedPersonId",
        type: "text",
        placeholder: "Please Enter",
        showInModes: ["view"],
        readOnly: true,
      },
      {
        label: "Tele Mobile No.",
        name: "tele_mobile_number",
        type: "number",
        placeholder: "Please Enter",
        showInModes: ["view"],
        readOnly: true,
      },
      {
        label: "Remarks",
        name: "remarks",
        type: "textarea",
        colspan: 24,
      },
    ],
  };

  const {
    appform,
    state: modalState,
    openModal,
    closeModal,
    handleValuesChange,
  } = useModalForm(modalConfigs, {});

  // ----------------- API helpers -----------------
  const safeGetLeads = async (payload = {}) => {
    setIsFetching(true);
    try {
      const res = await props.apis.apiGetLeads(payload);
      setTableData(res.data || []);
      setRowcount(res.total || 0);
    } finally {
      setIsFetching(false);
    }
  };

  const getLeads = (params = {}, reset = false) => {
    console.log({ params, reset });

    let resetPayload = {};
    // compose payload
    const pageParams = Object.fromEntries(
      new URLSearchParams(window.location.search)
    );
    if (pageParams.source) resetPayload.source = pageParams.source;

    if ([_enum.ROUTE_PERSONAS.admin].includes(activeKey)) {
      resetPayload.assigned_role = activeKey;
      resetPayload.status = "INTERESTED,OPEN";
    }
    if ([_enum.ROUTE_PERSONAS.telecaller].includes(activeKey)) {
      resetPayload.assigned_role = activeKey;
      resetPayload.status = [
        "OPEN",
        "NOT_INTERESTED",
        "INTERESTED",
        "NOT_REACHABLE",
        "CALL_NOT_ANSWERED",
        "PENDING",
        "NOT_ELIGIBLE",
      ].join(",");
    }
    if ([_enum.ROUTE_PERSONAS.ops].includes(activeKey)) {
      resetPayload.assigned_role = activeKey;
      resetPayload.status = [
        "OPEN",
        "NOT_INTERESTED",
        "INTERESTED",
        "NOT_REACHABLE",
        "CALL_NOT_ANSWERED",
        "PENDING",
        "NOT_ELIGIBLE",
      ].join(",");
    }

    if (["newopsleads"].includes(activeOpsKey)) {
      resetPayload.assigned_role = _enum.ROUTE_PERSONAS.ops;
      resetPayload.status = "INTERESTED,OPEN";
    }

    if (["actionedopsleads"].includes(activeOpsKey)) {
      resetPayload.assigned_role = _enum.ROUTE_PERSONAS.ops;
      resetPayload.status = [
        "NOT_INTERESTED",
        "NOT_REACHABLE",
        "CALL_NOT_ANSWERED",
        "PENDING",
        "NOT_ELIGIBLE",
        // "APPLIED",
      ].join(",");
    }

    const base = reset
      ? {
          limit: search.limit,
          order_by: search.order_by,
          order_direction: search.order_direction,
          page: 1,
          ...resetPayload,
        }
      : search;
    const final = { ...base, ...params };
    setSearch(final);
    safeGetLeads(final);
  };

  const getEmployees = async (role) => {
    const res = await props.apis.apiGetAllEmployees({
      role:
        role === _enum.ROUTE_PERSONAS.admin
          ? _enum.ROUTE_PERSONAS.telecaller
          : role,
    });
    if (res) {
      const employeeLists = res?.data;
      console.log({ employeeLists });
      setEmployees(employeeLists.options("employee_id", "full_name"));
    }
  };

  // simplified getData controlling assigned_role by activeKey
  const getData = (params = {}) => {
    // compose payload
    const pageParams = Object.fromEntries(
      new URLSearchParams(window.location.search)
    );
    if (pageParams.source) params.source = pageParams.source;

    if ([_enum.ROUTE_PERSONAS.admin].includes(activeKey)) {
      params.assigned_role = activeKey;
      params.status = "INTERESTED,OPEN";
    }
    if ([_enum.ROUTE_PERSONAS.telecaller].includes(activeKey)) {
      params.assigned_role = activeKey;
      params.status = [
        "OPEN",
        "NOT_INTERESTED",
        "INTERESTED",
        "NOT_REACHABLE",
        "CALL_NOT_ANSWERED",
        "PENDING",
        "NOT_ELIGIBLE",
      ].join(",");
    }
    if ([_enum.ROUTE_PERSONAS.ops].includes(activeKey)) {
      params.assigned_role = activeKey;
      params.status = [
        "OPEN",
        "NOT_INTERESTED",
        "INTERESTED",
        "NOT_REACHABLE",
        "CALL_NOT_ANSWERED",
        "PENDING",
        "NOT_ELIGIBLE",
      ].join(",");
    }

    if (["newopsleads"].includes(activeOpsKey)) {
      params.assigned_role = _enum.ROUTE_PERSONAS.ops;
      params.status = "INTERESTED,OPEN";
    }

    if (["actionedopsleads"].includes(activeOpsKey)) {
      params.assigned_role = _enum.ROUTE_PERSONAS.ops;
      params.status = [
        "NOT_INTERESTED",
        "NOT_REACHABLE",
        "CALL_NOT_ANSWERED",
        "PENDING",
        "NOT_ELIGIBLE",
        // "APPLIED",
      ].join(",");
    }
    console.log({ params, activeKey, activeOpsKey });

    getLeads(params);
  };

  // ----------------- actions -----------------
  const view = async (record, modalType) => {
    const data = await props.apis.apiGetLeadsById({ lead_id: record.lead_id });
    setEditData(data);
    openModal(modalType, "view", "View Lead", { ...data });
  };

  const edit = async (record, modalType) => {
    const data = await props.apis.apiGetLeadsById({ lead_id: record.lead_id });
    setEditData(data);
    if (modalType === "opsLeadInfo") {
      const filteredData = {
        lead_name: data?.lead_name,
        mobile_number: data?.mobile_number,
        bank_name: data?.bank_name,
        application_number: data?.application_number,
        application_date: data?.application_date,
        loan_amount: data?.loan_amount,
        status: data?.status,
        assignedPersonId: data?.assignedByEmployee?.full_name,
        tele_mobile_number: data?.assignedByEmployee?.mobile_number,
        remarks: data?.remarks,
      };
      openModal(modalType, "edit", "Edit Lead", { ...data });
    } else {
      openModal(modalType, "edit", "Edit Lead", { ...data });
    }
  };

  const handleAppModalSubmit = async (data) => {
    const payload = {
      ...Object.except(Object.removeEmpty(data), [
        "assignedPersonId",
        "tele_mobile_number",
      ]),
    };
    if (modalState.mode === "edit") {
      await props.apis.apiUpdateOpsLead(payload, { lead_id: editData.lead_id });
      swal2.fire({
        title: "Lead updated successfully.",
        icon: "success",
        iconColor: "#008AD1",
        timer: 4000,
      });
      closeModal();
      if (modalState.type === "opsLeadInfo")
        props.navigate("/app/applications");
      getData();
    } else if (modalState.mode === "add") {
      await props.apis.apiAddLead(payload);
      swal2.fire({
        title: "Lead added successfully.",
        icon: "success",
        iconColor: "#008AD1",
        timer: 4000,
      });
      closeModal();
      getData();
    }
  };

  // bulk actions (upload, delete, assign)
  const [bulkUploadModalFields, setBulkUploadModalFields] = useState([
    {
      label: "File Upload (Max limit 10,000)",
      name: "file",
      type: "filearea",
      accept: ".xlsx, .xls",
      customcolspan: "12",
      required: true,
    },
  ]);
  const addBulkUploadModalFields = () => {
    const fields = (bulkUploadModalFields || []).reduce(
      (o, n) => ({ ...o, [n.name]: n }),
      {}
    );
    const formdata = Object.map(fields, (v, k) => "");
    setPopupBulkUploadFields(fields);
    setPopupBulkUploadData(formdata);
  };

  const handleBulkUploadSubmit = async (e, data) => {
    const payload = { file: data?.file };
    const res = await props.apis.apiBulkUploadLead(payload);
    if (res) {
      swal2.fire({
        title: "Bulk Uploaded Successfully.",
        text: `Records Uploaded : ${res?.count || 0}`,
        icon: "success",
        iconColor: "#008AD1",
        timer: 4000,
      });
      document.querySelector("#bulkUploadModal #bsmodalclose")?.click();
      getData();
    }
  };

  const downloadExcel = async () => {
    let payload = {
      assigned_role: isOps ? _enum.ROUTE_PERSONAS.ops : activeKey,
    };
    props.apis.apiExportLeads(payload).then(async (res) => {
      if (res) {
        let data = await res;
        let blob = new Blob([data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        let link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", `Leads_Details.xlsx`);
        link.click();
      }
    });
  };
  // ---------------------------------------------------------------

  // HANDLE CHANGE PASSWORD MODAL

  const [passwordModalOpen, setPasswordModalOpen] = useState(false);

  const handlePasswordSubmit = (values) => {
    let payload = {
      oldPassword: values.oldPassword,
      newPassword: values.newPassword,
    };

    props.apis.apiPasswordReset(payload).then((res) => {
      console.log({ apiPasswordReset: res });
      if (res.status === 200) {
        swal2
          .fire({
            title:
              "Password changed successfully, Please re-login with new password",
            icon: "success",
            iconColor: "#234C9B",
          })
          .then((result) => {
            if (result.isConfirmed) {
              setPasswordModalOpen(false);
              props?.apis?.applogout();
            }
          });
      }
    });
  };
  const deleteLead = (record) => {
    if (
      props?.$store?.user?.role === _enum.ROUTE_PERSONAS.admin &&
      record.isAssigned
    ) {
      swal2.fire({
        title: "Assigned leads cannot be deleted",
        icon: "error",
        timer: 3000,
      });
      return;
    }
    swal2
      .fire({
        title: "Are you sure you want to delete this lead?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#008AD1",
      })
      .then(async (result) => {
        if (result.isConfirmed) {
          await props.apis.apiDeleteLead({ lead_id: record.lead_id });
          swal2.fire({
            title: "Lead Deleted",
            text: "Lead deleted successfully !!",
            icon: "success",
            timer: 4000,
          });
          getData();
        }
      });
  };

  const handleAssignDept = (val) => {
    setAssignDept(val);
  };

  const handleSubmitAssignDept = async () => {
    const payload = {
      leads: [...selectedRowKeys],
      assigned_role: assignDept || "",
    };
    if (assignDept === null) {
      swal2.fire({
        title: "Please select any department",
        icon: "info",
        iconColor: "#008AD1",
      });
      return;
    } else {
      const res = await props.apis.apiAssignDeptToLead(payload);
      if (res) {
        swal2.fire({
          title: "Lead Assigned",
          text: "Lead assigned successfully !!",
          icon: "success",
          timer: 4000,
        });
        // clear select
        setSelectedRowKeys([]);
        getData();
      }
    }
  };

  // ----------------------------------------------------------------
  // ASSIGN TO
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [assignedToId, setAssignedToId] = useState(null);
  const [assigntoform] = Form.useForm();

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    assigntoform.resetFields();
  };

  const openAssignedToModal = (record) => {
    console.log({ record });

    setAssignedToId([record?.lead_id]);
    getEmployees(activeKey);
    showModal();
  };

  const handleAssignedTo = async (e, data) => {
    let assignedToValue = data?.assignedTo;

    console.log({ data });

    const payload = {
      assigned_person_id: assignedToValue || "",
    };
    if (assignedToValue === null || assignedToValue === "") {
      swal2.fire({
        title: "Please select any telecallers",
        icon: "info",
        iconColor: "#008AD1",
      });
      return;
    } else {
      const res = await props.apis.apiAssignSingleLead(payload, {
        lead_id: assignedToId,
      });
      if (res) {
        swal2.fire({
          title: `Lead assigned ${
            activeKey === _enum.ROUTE_PERSONAS.admin
              ? "to Telecaller"
              : activeKey === _enum.ROUTE_PERSONAS.ops
              ? "to Sales Team"
              : ""
          } successfully.`,
          icon: "success",
          iconColor: "#234C9B",
          confirmButtonText: "Ok",
          timer: 4000,
        });
        assigntoform.resetFields();
        setIsModalOpen(false);
        getLeads();
      }
    }
  };

  // ----------------------------------------------------------------

  const deleteBulkLeads = async () => {
    const payload = { leadIds: [...selectedRowKeys] };
    const res = await props.apis.apiDeleteBulkLeads(payload);
    if (res) {
      swal2.fire({
        title: `${res?.message || "Leads deleted successfully"}`,
        icon: "success",
        timer: 3000,
      });
      setSelectedRowKeys([]);
      getData();
    }
  };

  // roles & telecallers
  const getRoles = async () => {
    const res = await props.apis.apiGetMasterStaticValues();
    if (res) {
      const rolesList = res?.roles?.filter((v) => v !== "ADMINISTRATOR");
      console.log({ rolesList });

      setRoles(rolesList.options ? rolesList.options() : rolesList);
    }
  };

  // ----------------- UI helpers -----------------
  const filterTabData = [
    { key: _enum.ROUTE_PERSONAS.admin, name: "New Leads" },
    { key: _enum.ROUTE_PERSONAS.telecaller, name: "Assigned to tele callers" },
    { key: _enum.ROUTE_PERSONAS.ops, name: "Sales Team Leads" },
  ];
  const opsFilterTabData = [
    { key: "newopsleads", name: "New Leads" },
    {
      key: "actionedopsleads",
      name: "Actioned Leads",
    },
  ];

  const handleSelect = (e, key) => {
    setActiveKey(key);
    props.navigate(`/app/leadmanagement?activetab=${key}`);
    window.location.reload();
  };

  const handleOpsSelect = (e, key) => {
    setActiveOpsKey(key);
    props.navigate(`/app/leadmanagement?activeopstab=${key}`);
  };

  // ----------------- lifecycle -----------------
  useEffect(() => {
    const loggedInUser = props?.$store?.user?.role;

    setIsadmin(loggedInUser === _enum.ROUTE_PERSONAS.admin);
    setIsTelecaller(loggedInUser === _enum.ROUTE_PERSONAS.telecaller);
    setIsOps(loggedInUser === _enum.ROUTE_PERSONAS.ops);

    const { emailAddress } = props?.$store?.logged || {};
    const { isPasswordUpdated } = props?.$store?.user || {};

    if (!isPasswordUpdated && emailAddress !== undefined) {
      setPasswordModalOpen(true);
    }

    // Set activeKey only once on mount
    const paramsActiveTab = props.urlparams?.params?.activetab;
    const paramsOpsActiveTab = props.urlparams?.params?.activeopstab;
    console.log({ paramsActiveTab, paramsOpsActiveTab });

    if (loggedInUser === _enum.ROUTE_PERSONAS.admin) {
      setActiveKey(paramsActiveTab || _enum.ROUTE_PERSONAS.admin);
    } else if (loggedInUser === _enum.ROUTE_PERSONAS.telecaller) {
      setActiveKey(_enum.ROUTE_PERSONAS.telecaller);
    } else if (loggedInUser === _enum.ROUTE_PERSONAS.ops) {
      setActiveOpsKey(paramsOpsActiveTab || "newopsleads");
    }

    getRoles();
  }, []);

  // fetch data when activeKey is set (avoids multiple calls)
  useEffect(() => {
    if (activeKey) {
      if (isadmin || isTelecaller) {
        getData();
      }
    }
  }, [activeKey]);

  useEffect(() => {
    if (activeOpsKey) {
      if (isOps) {
        getData();
      }
    }
  }, [activeOpsKey]);

  // expose some internals (legacy)
  props.$setNode && props.$setNode({ props, search, rowcount });

  return (
    <>
      <MainPagetitle
        mainTitle={isOps ? "Assigned Leads" : "Lead Management"}
        pageTitle={"Lead Management"}
        parentTitle={"Home"}
        pageIcon={imagepaths.SingleUserIconActive}
      />

      <div className="container-fluid position-relative pt-0 mt-4 mx-auto">
        {isadmin && (
          <div className="filter_tab_container px-4">
            {filterTabData.map((btn) => (
              <button
                key={btn.key}
                type="button"
                id={btn.key}
                className={Object.className({ active: activeKey === btn.key })}
                onClick={(...args) => handleSelect(...args, btn.key)}
              >
                {btn.name}
              </button>
            ))}
          </div>
        )}

        {(isadmin || isOps) && (
          <Flex
            gap="middle"
            align="center"
            justify="end"
            className="px-5 py-3 bg-md-white position-md-absolute end-0 top-0"
          >
            {isadmin && (
              <div style={{ width: 200 }}>
                <Select
                  style={{ width: "100%" }}
                  allowClear
                  placeholder="Assign To"
                  options={roles?.map((v) => ({
                    value: v.key,
                    label: v.label,
                  }))}
                  onChange={(...args) => handleAssignDept(...args)}
                  disabled={notSelected}
                />
              </div>
            )}

            {/* SHOW +ADD LEAD ONLY FOR ADMIN "NEW LEADS" TAB */}
            {!(
              props?.$store?.user?.role === "ADMINISTRATOR" &&
              (activeKey === _enum.ROUTE_PERSONAS.telecaller ||
              activeKey === _enum.ROUTE_PERSONAS.ops)
            ) && (
              <Button
                type="primary"
                className="btn btn-primary"
                htmlType="button"
                style={{ maxWidth: 150 }}
                onClick={() =>
                  openModal("leadInfo", "add", "Add Lead", { source: "SELF" })
                }
              >
                + Add Lead
              </Button>
            )}
          </Flex>
        )}

        {/* HIDE FOR OPS TEAM */}
        {/* {!isOps && <LeadCard activetab={activeKey} />} */}

        {isOps && (
          <div className="filter_tab_container px-4">
            {opsFilterTabData.map((btn) => (
              <button
                key={btn.key}
                type="button"
                id={btn.key}
                className={Object.className({
                  active: activeOpsKey === btn.key,
                })}
                onClick={(...args) => handleOpsSelect(...args, btn.key)}
              >
                {btn.name}
              </button>
            ))}
          </div>
        )}
        <div className="row">
          <div className="col-xl-12">
            <div className="card border-0">
              <div className="card-body p-0">
                <Flex
                  gap="middle"
                  align="center"
                  justify="end"
                  className="px-3 pt-3 pb-3"
                >
                  <Space size="small" split={<Divider type="vertical" />} wrap>
                    {isadmin && (
                      <>
                        <AppButton
                          variant="download"
                          type="text"
                          href={props.apis.apiDownloadLeadsTemplate()}
                        >
                          Download Template
                        </AppButton>
                        <AppButton
                          variant="upload"
                          onClick={addBulkUploadModalFields}
                          data-bs-toggle="modal"
                          data-bs-target="#bulkUploadModal"
                        >
                          Bulk Upload
                        </AppButton>
                      </>
                    )}

                    {isAdmin && (
                      <>
                        <AppButton
                          variant="delete"
                          onClick={deleteBulkLeads}
                          disabled={notSelected}
                        >
                          Delete Multiple Leads
                        </AppButton>
                      </>
                    )}

                    <AppButton
                      variant="excel"
                      onClick={(e) => downloadExcel(e)}
                    >
                      Download Excel
                    </AppButton>
                    <LeadsSearch
                      onSearch={(...arg) => getLeads(...arg)}
                      activeKey={activeKey}
                    />
                  </Space>
                </Flex>

                <AppTable
                  data={tableData}
                  columns={columns}
                  onChange={(...arg) => {
                    const page = arg[0];
                    setSearch((prev) => ({
                      ...prev,
                      page: page.current,
                      limit: page.pageSize,
                    }));
                    getData({ page: page.current, limit: page.pageSize });
                  }}
                  total={rowcount}
                  reorder
                  checkbox
                  loading={isFetching}
                  {...(isTelecaller
                    ? {
                        viewAction: (e) => view(e, "leadInfo"),
                        editAction: (e) => edit(e, "leadInfo"),
                        deletable: false,
                        assignedToLink: false,
                        rowSelection,
                      }
                    : isOps
                    ? {
                        viewable: false,
                        deletable: false,
                        assignedToLink: false,
                        editAction: (e) => edit(e, "leadInfo"),
                      }
                    : {
                        viewAction: (e) => view(e, "leadInfo"),
                        editAction: (e) => edit(e, "leadInfo"),
                        deleteAction: (e) => deleteLead(e),
                        rowSelection,
                        assignedToLink: [
                          _enum.ROUTE_PERSONAS.admin,
                          _enum.ROUTE_PERSONAS.ops,
                        ].includes(activeKey)
                          ? true
                          : false,
                        assignedToLinkAction: (e) => openAssignedToModal(e),
                      })}
                />

                <AppFormModal
                  form={appform}
                  title={modalState.title}
                  open={modalState.open}
                  onValuesChange={handleValuesChange}
                  onClose={closeModal}
                  fields={modalState.fields}
                  onSubmit={handleAppModalSubmit}
                  mode={modalState.mode}
                  persona={props?.$store?.user?.role}
                />

                <div className="col-12 text-end py-4">
                  <button
                    className={Object.className({
                      "btn btn-primary m-3": true,
                      disabled: selectedRowKeys.length == 0,
                      hidden: activeKey !== _enum.ROUTE_PERSONAS.telecaller,
                    })}
                    // onClick={() => setShow(true)}
                  >
                    Re-Assign Leads
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className={Object.className({
            row: true,
            hidden: activeKey !== _enum.ROUTE_PERSONAS.admin,
          })}
        >
          <div className="col-12 text-end">
            <button
              className={Object.className({
                "btn btn-primary me-5": true,
                hidden: isOps,
              })}
              disabled={notSelected}
              onClick={(...args) => handleSubmitAssignDept(...args)}
            >
              Submit
            </button>
          </div>
        </div>
      </div>

      <LeadsCenteredModal
        id="bulkUploadModal"
        className="modal-lg"
        modalSize="default"
        title="Bulk Upload"
        submitText="Upload"
        data={popupBulkUploadData}
        fields={popupBulkUploadFields}
        onSubmit={handleBulkUploadSubmit}
        modaltype="centeredmodal"
        onClose={() =>
          document.querySelector("#bulkUploadModal #bsmodalclose")?.click()
        }
      />

      <AppChangePasswordModal
        open={passwordModalOpen}
        onClose={() => setPasswordModalOpen(false)}
        onSubmit={handlePasswordSubmit}
      />

      {/* ASSIGNED TO MODAL (bootstrap) */}
      <AssignedToModal show={false} onSubmit={() => {}} />

      {/* ASSIGN TO MODAL */}
      <Modal show={isModalOpen} onHide={handleCancel} centered>
        <Modal.Header closeButton>
          <Modal.Title>Assign To</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AppForm onSubmit={handleAssignedTo}>
            <AppInput
              name="assignedTo"
              label="Assign To"
              type="select"
              options={employees?.map((v) => ({
                key: v.key,
                label: v.label,
              }))}
              required="true"
            />
            <Modal.Footer className="border-0 py-0">
              <button
                type="button"
                className="btn btn-primary-lite me-3"
                onClick={() => handleCancel()}
              >
                Cancel
              </button>
              <button type="submit" className="btn btn-primary">
                Submit
              </button>
            </Modal.Footer>
          </AppForm>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default constore(LeadManagement);

// Small helper component placeholder for assigned modal to keep this file single-file.
function AssignedToModal({ show, onSubmit }) {
  const [localShow, setLocalShow] = useState(show);
  useEffect(() => setLocalShow(show), [show]);
  return (
    <Modal show={localShow} onHide={() => setLocalShow(false)} centered>
      <Modal.Header closeButton>
        <Modal.Title>Re-Assign Leads</Modal.Title>
      </Modal.Header>
      <Modal.Body className="py-0">
        <AppForm onSubmit={onSubmit}>
          <AppInput
            name="employee_id"
            label="Assign To"
            type="select"
            options={[]}
          />
          <Modal.Footer>
            <button
              type="button"
              className="btn btn-primary-lite me-3"
              onClick={() => setLocalShow(false)}
            >
              Cancel
            </button>
            <button type="submit" className="btn btn-primary">
              Assign
            </button>
          </Modal.Footer>
        </AppForm>
      </Modal.Body>
    </Modal>
  );
}
